import {createSelector} from 'reselect';
import {getSettings} from '../../selectors';

const makeGetDoesAdyenV2SubTypeRequireGenericBillingAddress = adyenV2SubType => createSelector(
  [getSettings],
  settings => !!settings?.adyen_v2_sub_types_requiring_generic_billing_address?.includes(adyenV2SubType),
);

export default makeGetDoesAdyenV2SubTypeRequireGenericBillingAddress;
